import React, { Component } from 'react';
import { getGeometryType, updateFeature } from '../Utils/EdicioCapaUtils';
import VectorSource from 'ol/source/Vector';
import { Draw, Snap, Modify } from 'ol/interaction';
import GeoJSON from 'ol/format/GeoJSON';
import { getAllFeatures } from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Taula/TaulaUtils';
import { Text } from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Estadisticas/StatsElement';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { CardEditButtonWrapper } from '../InformacioDePunt/InformacioPuntCardElement';
import { Fill, Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import { ButtonStyle } from '../Navbar/Compartir/Componentes/Download/Load/LocalMaps/LocalMapsElement';

const featuresSource = new VectorSource();
const snapInteraction = new Snap({
  source: featuresSource
});

let draw;

export const modifyStyle = new Style({
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: 'rgba(0, 0, 0, 0.7)'
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.4)'
    })
  })
});
const styleEdit = new Style({
  fill: new Fill({
    color: 'rgba(192, 0, 0, 0.2)'
  }),
  stroke: new Stroke({
    color: 'rgba(192, 0, 0, 1)',
    // lineDash: [10, 10],
    width: 2
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: 'rgba(0, 0, 0, 0.7)'
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.2)'
    })
  })
});
export class EdicioCapa extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.modifyInteraction = new Modify({
      source: this.props.editVector.getSource(),
      style: modifyStyle
    });
  }

  componentDidMount = () => {
    document.addEventListener('keydown', this.onEscClick);
    if (this.props.mode !== 'deleteGeom') {
      this.obtainFeatInfo();
      this.obtainAllFeatures();
    } else {
      this.props.toggleDrawing(true);
      this.addInteraction('Point', true);
    }
  };

  onEscClick = (e) => {
    if (e.key === 'Escape') {
      this.props.setEditing(false, this.props.layer);
    }
  };

  obtainAllFeatures = async () => {
    featuresSource.clear();
    this.props.map.addInteraction(this.modifyInteraction);
    let fc = new GeoJSON().readFeatures(await getAllFeatures(this.props.layer, undefined, this.props.user));
    featuresSource.addFeatures(fc);
  };

  /**
   * @desc Obtener tipo y campos de datos de la capa
   */
  obtainFeatInfo = async () => {
    const type = await getGeometryType(this.props.layer);
    this.addInteraction(type);
  };

  /**
   * @desc Abre el modal de confirmación de borrar la geometría
   */
  toggleDeleteGeomModal = (feature) => {
    const Component = () => (
      <>
        <Text>{getTranslatedKey('deleteGeomWarn')}</Text>
        <CardEditButtonWrapper>
          <ButtonStyle onClick={() => this.props.toggleAlert(false)}>{getTranslatedKey('cancel')}</ButtonStyle>
          <ButtonStyle eliminar onClick={() => this.acceptDelete(feature)}>
            {getTranslatedKey('delete')}
          </ButtonStyle>
        </CardEditButtonWrapper>
      </>
    );
    this.props.toggleAlert(true, <Component />, 'Atenció', false);
  };

  acceptDelete = (feature) => {
    let source = this.props.editVector.getSource();
    source.removeFeature(feature);
    updateFeature(this.props.layer, source, this.props.editFeature, this.props.setEditing, true);
    if (source.getFeatures().length === 1) {
      this.props.setEditing(false, this.props.layer);
    }
    this.props.toggleAlert(false);
  };

  /**
   * @desc Interacción para pintar la feature nueva
   */
  addInteraction = (type, borrar) => {
    draw = new Draw({
      type: type,
      source: borrar ? null : this.props.editVector.getSource(),
      trace: type !== 'MultiPoint',
      style: [styleEdit],
      traceSource: featuresSource,
      geometryName: this.props.layer.getExtension().Geometry
    });
    draw.set('name', 'edit');
    draw.on('drawend', (e) => {
      if (borrar) {
        let pointClickedCoord = e.feature.getGeometry().getCoordinates();
        const pixel = this.props.map.getPixelFromCoordinate(pointClickedCoord);
        let count = 0;
        this.props.map.forEachFeatureAtPixel(
          pixel,
          (feature, layer) => {
            if (layer === this.props.editVector) {
              count++;
              this.toggleDeleteGeomModal(feature);
            }
          },
          { layerFilter: undefined, hitTolerance: 10 }
        );
        if (count === 0) {
          this.props.setEditing(false, this.props.layer);
        }
      } else {
        this.props.setEditing(true, this.props.layer, this.props.mode);
      }
    });

    this.props.map.addInteraction(draw);
    type !== 'MultiPoint' && this.props.map.addInteraction(snapInteraction);
  };

  render() {
    return <></>;
  }
}
